var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sec-title"),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            [
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  attrs: { src: require("assets/imgs/eth_logo.svg") }
                }),
                _vm._v("ETH\n            "),
                _c(
                  "span",
                  {
                    staticClass: "record __pointer",
                    on: { click: _vm.toRecord }
                  },
                  [_vm._v(_vm._s(_vm.$t("walletConversion.record")))]
                )
              ]),
              _vm._v(" "),
              _c(
                "vite-address",
                {
                  attrs: {
                    title: _vm.$t("wallet.address"),
                    address: _vm.address,
                    addressQrcode: "ethereum:" + _vm.address
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hideAddrList,
                          expression: "hideAddrList"
                        }
                      ],
                      staticClass: "address-wrapper"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "active-addr __pointer",
                          on: { click: _vm.showAddrList }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.address) +
                              "\n                    "
                          ),
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addrList && _vm.addrList.length,
                                expression: "addrList && addrList.length"
                              }
                            ],
                            class: {
                              slide: true,
                              down: !_vm.isShowAddrList,
                              up: _vm.isShowAddrList
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.addrList &&
                                _vm.addrList.length &&
                                _vm.isShowAddrList,
                              expression:
                                "addrList && addrList.length && isShowAddrList"
                            }
                          ],
                          staticClass: "addr-list __pointer"
                        },
                        _vm._l(_vm.addrList, function(addr, index) {
                          return _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: addr.hexAddr !== _vm.address,
                                  expression: "addr.hexAddr !== address"
                                }
                              ],
                              key: index,
                              on: {
                                click: function($event) {
                                  return _vm.changeActiveAddr(addr)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(addr.hexAddr) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "token-list" },
                _vm._l(_vm.tokenList, function(token, index) {
                  return _c("token", {
                    key: index,
                    attrs: {
                      sendTx: _vm.showTrans,
                      token: token,
                      ethToken: _vm.tokenList.eth
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "note" }, [
                _vm._v(_vm._s(_vm.$t("walletConversion.note")))
              ]),
              _vm._v(" "),
              !!_vm.transType
                ? _c("transaction", {
                    attrs: {
                      closeTrans: _vm.hideTrans,
                      ethWallet: _vm.ethWallet,
                      transType: _vm.transType,
                      token: _vm.tokenList[_vm.transToken]
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c("loading", { staticClass: "loading" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }